module.exports = __webpack_public_path__ + "img/hero-bg.c9cb4c06.png";